// -------- Includes --------
export const CONTENT_INCLUDE = 'content';
export const CONTENTTYPE_INCLUDE = 'contentType';
export const COMMENT_INCLUDE = 'comment';
export const COMMENTDECLINEINFO_INCLUDE = 'commentDeclineInfo';
export const COMMENTTYPE_INCLUDE = 'commentType';
export const COMMENTSTATUS_INCLUDE = 'commentStatus';
export const COMPANY_INCLUDE = 'company';
export const COMPANYHEARINGROLE_INCLUDE = 'companyHearingRole';
export const FIELDTYPESPECIFICATION_INCLUDE = 'fieldTypeSpecification';
export const USERHEARINGROLE_INCLUDE = 'userHearingRole';
export const USER_INCLUDE = 'user';
export const HEARING_INCLUDE = 'hearing';
export const HEARINGROLE_INCLUDE = 'hearingRole';
export const HEARINGTEMPLATE_INCLUDE = 'hearingTemplate';
export const HEARINGSTATUS_INCLUDE = 'hearingStatus';
export const HEARINGTYPE_INCLUDE = 'hearingType';
export const CITYAREA_INCLUDE = 'cityArea';
export const SUBJECTAREA_INCLUDE = 'subjectArea';
export const KLEMAPPING_INCLUDE = 'kleMapping';
export const KLEHIERARCHY_INCLUDE = 'kleHierarchy';
export const NOTIFICATIONCONTENT_INCLUDE = 'notificationContent';
export const NOTIFICATIONCONTENTTYPE_INCLUDE = 'notificationContentType';
export const NOTIFICATIONTYPE_INCLUDE = 'notificationType';
export const NOTIFICATIONQUEUE_INCLUDE = 'notificationQueue';
export const FIELD_INCLUDE = 'field';
export const FIELDTYPE_INCLUDE = 'fieldType';
export const FIELDTEMPLATE_INCLUDE = 'fieldTemplate';
export const USERCAPACITY_INCLUDE = 'userCapacity';
export const USERCAPACITYMAPPING_INCLUDE = 'userCapacityMapping';
export const INVITATIONKEY_INCLUDE = 'invitationKey';
export const INVITATIONGROUPMAPPING_INCLUDE = 'invitationGroupMapping';
export const INVITATIONSOURCEMAPPING_INCLUDE = 'invitationSourceMapping';

// -------- Models --------
export const COMPANY_TYPE = 'company';
export const CONTENT_TYPE = 'content';
export const COMPANYHEARINGROLE_TYPE = 'companyHearingRole';
export const GLOBALCONTENT_TYPE = 'globalContent';
export const HEARING_TYPE = 'hearing';
export const HEARINGROLE_TYPE = 'hearingRole';
export const HEARINGTEMPLATE_TYPE = 'hearingTemplate';
export const HEARINGTYPE_TYPE = 'hearingType';
export const CITYAREA_TYPE = 'cityArea';
export const SUBJECTAREA_TYPE = 'subjectArea';
export const USER_TYPE = 'user';
export const USERHEARINGROLE_TYPE = 'userHearingRole';
export const KLEMAPPING_TYPE = 'kleMapping';
export const KLEHIERARCHY_TYPE = 'kleHierarchy';
export const NOTIFICATIONCONTENT_TYPE = 'notificationContent';
export const NOTIFICATIONCONTENTTYPE_TYPE = 'notificationContentType';
export const NOTIFICATIONTYPE_TYPE = 'notificationType';
export const NOTIFICATIONQUEUE_TYPE = 'notificationQueue';
export const FIELDTEMPLATE_TYPE = 'fieldTemplate';
export const FIELD_TYPE = 'field';
export const VALIDATION_RULE = 'validationRule';
export const FIELDTYPE_TYPE = 'fieldType';
export const FIELDTYPESPECIFICATION_TYPE = 'fieldTypeSpecification';
export const INVITATIONGROUP_TYPE = 'invitationGroup';
export const INVITATIONGROUPMAPPING_TYPE = 'invitationGroupMapping';
export const INVITATIONKEY_TYPE = 'invitationKey';
export const INVITEEIDENTIFIERS_TYPE = 'inviteeIdentifiers';

// -------- ENUMS --------
export const HEARINGROLE_OWNER = 1;
export const HEARINGROLE_INVITEE = 2;
export const HEARINGROLE_REVIEWER = 3;
export const HEARINGROLE_RESPONDER = 4;

export const USERCAPACITY_EMPLOYEE = 1;
export const USERCAPACITY_CITIZEN = 2;
export const USERCAPACITY_COMPANY = 3;

export const CONTENTTYPE_TEXT = 1;
export const CONTENTTYPE_FILE = 2;

export const COMMENTTYPE_HEARING_RESPONSE = 1;
export const COMMENTTYPE_HEARING_REVIEW = 2;
export const COMMENTTYPE_HEARING_RESPONSE_REPLY = 3;

export const COMMENTSTATUS_NONE = 0;
export const COMMENTSTATUS_AWAITING_APPROVAL = 1;
export const COMMENTSTATUS_APPROVED = 2;
export const COMMENTSTATUS_NOTAPPROVED = 3;

export const FILEOPERATION_ADD = 1;
export const FILEOPERATION_DELETE = 2;

export const HEARINGSTATUS_CREATED = 1;
export const HEARINGSTATUS_DRAFT = 2;
export const HEARINGSTATUS_AWAITING_STARTDATE = 3;
export const HEARINGSTATUS_ACTIVE = 4;
export const HEARINGSTATUS_AWAITING_CONCLUSION = 5;
export const HEARINGSTATUS_CONCLUDED = 6;

export const FIELDTYPE_TITLE = 1;
export const FIELDTYPE_SUMMARY = 2;
export const FIELDTYPE_BODYINFORMATION = 3;
export const FIELDTYPE_CONCLUSION = 4;
export const FIELDTYPE_ESDH_TITLE = 5;
export const FIELDTYPE_IMAGE = 6;

export const ERRORCODE_UNKNOWN = '0';
export const ERRORCODE_NOTFOUND = '1';
export const ERRORCODE_FORBIDDENACCESS = '2';
export const ERRORCODE_INVALIDOPERATION = '3';
export const ERRORCODE_UNAUTHORIZEDACCESS = '4';
export const ERRORCODE_VALIDATION = '5';
export const ERRORCODE_INVALIDMODELSTATE = '6';
export const ERRORCODE_FILEUPLOAD = '7';
export const ERRORCODE_KLEMAPPING = '8';
export const ERRORCODE_EMPTYCONCLUSION = '9';
export const ERRORCODE_SBSIPAUTHORIZATION = '10';
export const ERRORCODE_INVALIDCSVCONTENT = '12';

export const GLOBALCONTENTTYPE_TERMSANDCONDITIONS = 1;

export const HEARING_EXPORT_FORMAT_NONE = 0;
export const HEARING_EXPORT_FORMAT_EXCEL = 1;
export const HEARING_EXPORT_FORMAT_PDF = 2;
export const HEARING_EXPORT_FORMAT_FULL_PDF = 3;
export const HEARING_EXPORT_FORMAT_USER_REPORT_EXCEL = 4;
export const HEARING_EXPORT_FORMAT_HEARING_RESPONSE_EXCEL = 5;

export const INVITATIONSOURCETYPE_NONE = 0;
export const INVITATIONSOURCETYPE_PERSONAL = 1;
export const INVITATIONSOURCETYPE_INVITATION_GROUP = 2;
export const INVITATIONSOURCETYPE_CSV = 3;
export const INVITATIONSOURCETYPE_EXCEL = 4;

export const NOTIFICATIONCONTENTTYPE_NONE = 0;
export const NOTIFICATIONCONTENTTYPE_SUBJECT = 1;
export const NOTIFICATIONCONTENTTYPE_HEADER = 2;
export const NOTIFICATIONCONTENTTYPE_BODY = 3;
export const NOTIFICATIONCONTENTTYPE_FOOTER = 4;

export const NOTIFICATIONTYPE_NONE = 0;
export const NOTIFICATIONTYPE_ADDED_AS_REVIEWER = 1;
export const NOTIFICATIONTYPE_INVITED_TO_HEARING = 2;
export const NOTIFICATIONTYPE_HEARING_ANSWER_RECEIPT = 3;
export const NOTIFICATIONTYPE_HEARING_CONCLUSION_PUBLISHED = 4;
export const NOTIFICATIONTYPE_HEARING_CHANGED = 5;
export const NOTIFICATIONTYPE_HEARING_RESPONSE_DECLINE = 6;
export const NOTIFICATIONTYPE_DAILY_STATUS = 7;
export const NOTIFICATIONTYPE_NEWSLETTER = 8;

export const NOTIFICATIONDELIVERYSTATUS_UNKNOWN = 0;
export const NOTIFICATIONDELIVERYSTATUS_AWAITING = 1;
export const NOTIFICATIONDELIVERYSTATUS_SUCCESSFUL = 2;
export const NOTIFICATIONDELIVERYSTATUS_FAILED = 3;

export const NOTIFICATIONSENTAS_UNKNOWN = 0;
export const NOTIFICATIONSENTAS_EMAIL = 1;
export const NOTIFICATIONSENTAS_DIGITAL_LETTER = 2;
export const NOTIFICATIONSENTAS_PHYSICAL_LETTER = 3;
